import type {
  PatchDocumentRequestType,
  PatchDocumentResponseType,
} from 'entities/document/api/types';
import { changeDateToStringInObject } from 'helpers/safeJsonStringify';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const patchDocument = async ({
  documentId,
  ...body
}: PatchDocumentRequestType) => {
  const url = `/api/v2/documents/${documentId}`;
  const { contractValues, ...rest } = body;

  // drop _contractCommon
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { _contractCommon, ...contractValuesData } = contractValues;

  const response = await apiAuthClient.patch<PatchDocumentResponseType>(url, {
    ...rest,
    contractValues: changeDateToStringInObject(contractValuesData),
  });

  return response.data;
};
